// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"dc681068","160":"51eb7abf","352":"51eb7abf","392":"037dc57c","451":"38af18fe","518":"09baaa54","996":"57e3db1b"}[chunkId] + ".chunk.css";
};